<div class="position-reletivediv popup-inner-space">
    <div class="text-right">
            <img src="assets/images/close.svg" class="img-fluid closeicon closeicon2 cursor-pointer" alt="..." (click)="Close()">
    </div>

<form class="" [formGroup]="setparameterForm" (ngSubmit)="OnSubmit()"  class="flatspace" id="setparameterForm">

    <div class="row">
        <div class="text-field-container">
        <div class="fxg-field margin-top-5 col-lg-6 p-0">
                <label style="display:none;" class="Navuser">Price Input
                    </label>
                <input type="text" class="fxg-field__input-text fxg-field__input--required sessioncamexclude"
                    formControlName="UnitRate" id="UnitRate" name="UnitRate" title="Price Input"
                   required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}"
                    data-errmsg="Sorry, this is a required field.">
                <span class="fxg-field__placeholder fxg-field__floating-placeholder"
                    tabindex="-1">Price Input</span>
                    <div style="position: relative;">
                      <p class="error_msg" *ngIf="UnitRate">{{UnitRate}}</p>
                  </div>
        </div>
        <div class="fxg-field margin-top-5 col-lg-6 p-0">
            <label style="display:none;" class="Navuser">Power Factor Panelty
            </label>
        <input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
            formControlName="PowerFactorPenalty" id="PowerFactorPenalty" name="PowerFactorPenalty" title="Power Factor Panelty"
            maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}"
            data-errmsg="Sorry, this is a required field.">
        <span class="fxg-field__placeholder fxg-field__floating-placeholder"
            tabindex="-1">Power Factor Panelty</span>
            <div style="position: relative;">
              <p class="error_msg" *ngIf="PowerFactorPenalty">{{PowerFactorPenalty}}</p>
          </div>
            </div>
            <div class="fxg-field margin-top-5 col-lg-6 p-0"> 
  <div class="betweenheader">
    Threshold value
  </div>
</div>
<div class="fxg-field margin-top-5 col-lg-6 p-0"> 
    </div>
<div class="fxg-field margin-top-5 col-lg-6 p-0">
    <label style="display:none;" class="Navuser">Energy
    </label>
<input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
    formControlName="ThresholdEnergy" id="ThresholdEnergy" name="ThresholdEnergy" title="Energy" 
    maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
    data-errmsg="Sorry, this is a required field.">
<span class="fxg-field__placeholder fxg-field__floating-placeholder"
    tabindex="-1">Energy</span>
    </div>
    <div class="fxg-field margin-top-5 col-lg-6 p-0">
        <label style="display:none;" class="Navuser">Temprature
        </label>
    <input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
        formControlName="ThresholdTemperature" id="ThresholdTemperature" name="ThresholdTemperature" title="Temprature" 
        maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
        data-errmsg="Sorry, this is a required field.">
    <span class="fxg-field__placeholder fxg-field__floating-placeholder"
        tabindex="-1">Temprature</span>
    </div>
    <div class="fxg-field margin-top-5 col-lg-6 p-0">
        
    <label style="display:none;" class="Navuser">Humidity
    </label>
<input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
    formControlName="ThresholdHumidity" id="ThresholdHumidity" name="ThresholdHumidity" title="Humidity" 
    maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
    data-errmsg="Sorry, this is a required field.">
<span class="fxg-field__placeholder fxg-field__floating-placeholder"
    tabindex="-1">Humidity</span>
    </div>
    <div class="fxg-field margin-top-5 col-lg-6 p-0">   
    <label style="display:none;" class="Navuser">MDI
    </label>
<input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
    formControlName="ThresholdMDI" id="ThresholdMDI" name="ThresholdMDI" title="MDI" 
    maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
    data-errmsg="Sorry, this is a required field.">
<span class="fxg-field__placeholder fxg-field__floating-placeholder"
    tabindex="-1">MDI</span>
        </div>
        <div class="fxg-field margin-top-5 col-lg-6 p-0"> 
    <label style="display:none;" class="Navuser">Power Factor
    </label>
<input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
    formControlName="ThresholdPowerFactor" id="ThresholdPowerFactor" name="ThresholdPowerFactor" title="Power Factor" NumberWithDecimal
    maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
    data-errmsg="Sorry, this is a required field.">
<span class="fxg-field__placeholder fxg-field__floating-placeholder"
    tabindex="-1">Power Factor</span>
            </div>
            <div class="fxg-field margin-top-5 col-lg-6 p-0">
                
      <label style="display:none;" class="Navuser">Electricity Bill
    </label>
<input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
    formControlName="ThresholdElectricityBill" id="ThresholdElectricityBill" name="ThresholdElectricityBill" title="Electricity Bill" NumberWithDecimal
    maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
    data-errmsg="Sorry, this is a required field.">
<span class="fxg-field__placeholder fxg-field__floating-placeholder"
    tabindex="-1">Electricity Bill</span>
 
                </div>
                <div class="fxg-field margin-top-5 col-lg-6 p-0">
      <div class="betweenheader" style="display: none;">
        Analog Calibration:
      </div>
                </div>
                <div class="fxg-field margin-top-5 col-lg-6 p-0">
                    
      <div style="display: none;">
        <label style="display:none;" class="Navuser">Temprature
            </label>
        <input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
            formControlName="AnalogTemprature" id="AnalogTemprature" name="AnalogTemprature" title="Temprature"
            maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
            data-errmsg="Sorry, this is a required field.">
        <span class="fxg-field__placeholder fxg-field__floating-placeholder"
            tabindex="-1">Temprature</span>
        </div>
         </div>
         <div class="fxg-field margin-top-5 col-lg-6 p-0">
            <div style="display: none;">
                <label style="display:none;" class="Navuser">Humidity
                    </label>
                <input type="text" class="fxg-field__input-text12 fxg-field__input--required sessioncamexclude"
                    formControlName="AnalogHumidity" id="AnalogHumidity" name="AnalogHumidity" title="Humidity" 
                    maxlength="50" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly1}"
                    data-errmsg="Sorry, this is a required field.">
                <span class="fxg-field__placeholder fxg-field__floating-placeholder"
                    tabindex="-1">Humidity</span>
                </div>
      
             </div>
    </div>
</div>
    <div class="margin-top-20 save-cancel save-data fixed-button-popup" *ngIf="DisplayButton">
            <button class="btncommon" type="submit">Save</button>
            <button class="btncommon btn-border-add-company ml-24" (click)="OnCancel()">Cancel</button>
    </div>
</form>
</div>
